// Import job history register (BUILD_SPEC.md §5.9) — services/api/src/modules/
// importer/jobs.ts's `GET /importer/jobs`. Read-only list; open to any
// authenticated tenant member (only the mutating actions are ADMIN-gated).
import { Alert, Paper, Stack, Table, Text, Title } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { ApiRequestError } from '../../../api/client';
import { DocStatusBadge } from '../../../components/DocStatusBadge';
import { useImportJobs } from '../api';

export function ImportJobHistory() {
  const { data, isLoading, isError, error } = useImportJobs();
  const rows = data?.items ?? [];

  return (
    <Stack gap="md">
      <Title order={3}>Import history</Title>
      <Text size="sm" c="dimmed">
        Every import job that's been created — validated dry runs and committed imports alike.
      </Text>

      {isError && (
        <Alert color="red" icon={<IconAlertCircle size={16} />}>
          {error instanceof ApiRequestError ? error.message : 'Failed to load import jobs.'}
        </Alert>
      )}

      <Paper withBorder radius="md">
        <Table.ScrollContainer minWidth={560}>
          <Table striped highlightOnHover verticalSpacing="sm">
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Kind</Table.Th>
                <Table.Th>Status</Table.Th>
                <Table.Th>Rows</Table.Th>
                <Table.Th>Errors</Table.Th>
                <Table.Th>Created</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows.map((row) => (
                <Table.Tr key={row.id}>
                  <Table.Td>{row.kind}</Table.Td>
                  <Table.Td>
                    <DocStatusBadge status={row.status} domain="importJob" />
                  </Table.Td>
                  <Table.Td>{row.rowCount}</Table.Td>
                  <Table.Td>{row.errorCount}</Table.Td>
                  <Table.Td>{new Date(row.createdAt).toLocaleString()}</Table.Td>
                </Table.Tr>
              ))}
              {!isLoading && rows.length === 0 && (
                <Table.Tr>
                  <Table.Td colSpan={5}>
                    <Text c="dimmed" ta="center" py="md">
                      No import jobs yet.
                    </Text>
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </Paper>
    </Stack>
  );
}
